import { useState } from 'react';

interface CareerCard {
  id: number;
  period: string;
  title: string;
  bgColor: string;
  image: string;
}

export default function CareerSection() {
  const [hoveredCard, setHoveredCard] = useState<number | null>(null);

  const careers: CareerCard[] = [
    {
      id: 1,
      period: '2005年〜2021年',
      title: '野球に打ち込む',
      bgColor: 'bg-pink-50',
      image: 'https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/4e066a104cf7803f023bd1a56acd3c2d.jpeg'
    },
    {
      id: 2,
      period: '2020年〜',
      title: 'トレーニング開始',
      bgColor: 'bg-emerald-50',
      image: 'https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/4905068887ec31178257bf61701b2f6f.jpeg'
    },
    {
      id: 3,
      period: '2024年6月〜',
      title: 'トレーナー業開始',
      bgColor: 'bg-gray-50',
      image: 'https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/507bf65058c24e2bcc97ac0b51e6ad78.jpeg'
    },
    {
      id: 4,
      period: '2025年〜',
      title: 'ベンチプレス本格開始',
      bgColor: 'bg-amber-50',
      image: 'https://static.readdy.ai/image/007f7bc53e0940ad9a8bca31c5534ed3/7393e15ee581e18ba1bc521e7138542c.jpeg'
    }
  ];

  return (
    <section id="career" className="py-24 px-6 lg:px-12 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-gray-900 text-white rounded-full text-xs tracking-widest" style={{ fontFamily: 'Montserrat, sans-serif' }}>
            CAREER
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {careers.map((career) => (
            <div
              key={career.id}
              className="rounded-3xl overflow-hidden shadow-lg cursor-pointer"
            >
              <div className="h-80 overflow-hidden">
                <img
                  src={career.image}
                  alt={career.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="p-6 bg-white">
                <h3 className="text-sm font-bold mb-1 leading-tight text-gray-400" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                  {career.period}
                </h3>
                <h4 className="text-base font-semibold text-gray-800" style={{ fontFamily: 'Noto Sans JP, sans-serif' }}>
                  {career.title}
                </h4>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
